import ServiceLocator from "../../ServiceLocator";
import Player from "./Player";
import SpecialCardAnimation from "./SpecialCardAnimation";

import * as PIXI from "pixi.js";
import gsap from "gsap";


export default class DrawTwoAnimation extends SpecialCardAnimation
{
    private _nextPlayer: Player = null;
    private _drawCount: number = null;

    private _iconWrapper: PIXI.Container = null;
    private _cardCountText: PIXI.Text = null;

    public set nextPlayer( value: Player ) { this._nextPlayer = value; }
    public set drawCount( value: number ) { this._drawCount = value; }


    public constructor()
    {
        super();
    }

    public init(): void
    {
        super.init();

        console.assert( this._nextPlayer != null, "DrawTwoAnimation.ts : init() :: this._nextPlayer cannot be null." );
        console.assert( this._drawCount != null, "DrawTwoAnimation.ts : init() :: this._drawCount cannot be null." );

        this._bannerText.text = "DRAW TWO";
        this._bannerText.style.fill = this._kArrHexColor[ this._color ];

        this._iconWrapper = new PIXI.Container();
        this._iconWrapper.visible = false;
        this.addChild( this._iconWrapper );
        //
        let iconShadow: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources[ "special_icon_draw-2_shadow" ].texture );
        iconShadow.anchor.set( 0.5 );
        iconShadow.position.set( -30.5 * 0.5, 32.5 * 0.5 );
        this._iconWrapper.addChild( iconShadow );
        //
        let icon: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources[ "special_icon_draw-2_" + [ "red", "yellow", "blue", "green" ][ this._color ] ].texture );
        icon.anchor.set( 0.5 );
        this._iconWrapper.addChild( icon );

        this._cardCountText = new PIXI.Text( "+" + this._drawCount.toString(), { fontFamily: "asap_bold", fontSize: 48, fill: 0x474747, stroke: 0xffffff, strokeThickness: 6, lineJoin: "round" } );
        this._cardCountText.anchor.set( 0.5 );
        this._cardCountText.visible = false;
        this._cardCountText.y = 20;
        this.addChild( this._cardCountText );
    }

    public end(): void
    {
        super.end();

        // TODO:
    }

    /*public play(): void
    {
        const kPlayerTargetPos: PIXI.Point = this.toLocal( this._nextPlayer.portraitGlobalPos );
        this._banner.visible = true;
        this._glow.visible = true;
        this._iconWrapper.visible = true;

        this._tl = new gsap.core.Timeline();
        this._tl.from( this._banner.scale, { y: 0, duration: 0.2, ease: "sine.in" }, 0 );
        this._tl.from( this._glow, { alpha: 0, duration: 0.2, ease: "sine.in" }, "<" );
        this._tl.from( this._frontWrapper.scale, { x: 2, y: 2, duration: 0.2, ease: "linear.inOut" }, "<" );
        this._tl.to( this._backWrapper, { x: "+=94", y: "-=71", duration: 0.4, ease: "sine.out" }, "<" );
        this._tl.to( this._iconWrapper, { x: kPlayerTargetPos.x, y: kPlayerTargetPos.y, duration: 0.4, ease: "sine.in" }, 1 );
        this._tl.to( this._iconWrapper.scale, { x: 0.4, y: 0.4, duration: 0.4, ease: "sine.in" }, "<" );
        this._tl.to( this._glow, { alpha: 0, duration: 0.2, ease: "sine.in" }, "<" );
        this._tl.to( this._banner.scale, { y: 0, duration: 0.2, ease: "sine.in" }, "<" );
        this._tl.to( this._iconWrapper.scale, { x: 0.5, y: 0.5, duration: 0.1, ease: "sine.out" }, 1.4 );
        this._tl.to( this._iconWrapper.scale, { x: 0.4, y: 0.4, duration: 0.1, ease: "sine.in" }, ">" );
        this._tl.call( () => { this._onCompleted.dispatch(); }, null, 1.8 );
        //
        ServiceLocator.game.tweenGroup.add( this._tl );
    }*/

    public play(): void
    {
        this._iconWrapper.visible = true;
        this._iconWrapper.scale.set( 0 );
        const kPlayerTargetPos: PIXI.Point = this.toLocal( this._nextPlayer.portraitGlobalPos );
        this._iconWrapper.position.copyFrom( kPlayerTargetPos );
        //
        this._cardCountText.position.copyFrom( this._iconWrapper.position );
        
        this._tl = new gsap.core.Timeline();
        this._tl.to( this._iconWrapper.scale, { x: 0.4, y: 0.4, duration: 0.2, ease: "back.out" } );
        this._tl.call( () => { this._cardCountText.visible = true; }, null, 0.2 );
        this._tl.to( this._iconWrapper, { alpha: 0, duration: 0.6, ease: "sine.in" }, 0.6 );
        this._tl.to( this._cardCountText, { alpha: 0, duration: 0.8, ease: "sine.in" }, 0.6 );
        this._tl.to( this._cardCountText.scale, { x: 1.4, y: 1.4, duration: 0.8, ease: "sine.in" }, 0.6 );
        this._tl.call( () => { this._onCompleted.dispatch(); } );
        //
        ServiceLocator.game.tweenGroup.add( this._tl );

        ServiceLocator.audio.playSfx( "draw_two_special" );
    }
}